import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";

import QuestionPoint from "./QuestionPoint";

const coordinates = [
    {x: 101, y: 206},
    {x: 137, y: 149},
    {x: 20, y: 159},
    {x: 174, y: 117},
    {x: 104, y: 111},
    {x: 184, y: 163},
    {x: 55, y: 126},
    {x: 47, y: 79},
    {x: 93, y: 63},
    {x: 142, y: 80},
    {x: 55, y: 31},
    {x: 54, y: 193},
    {x: 89, y: 159},
    {x: 147, y: 195},
    {x: 10, y: 111}
];

const Technology = (props) => {
    return (
        <svg viewBox="0 0 260 260">
            <g className="technology">
                <g className="points">
                    <circle fill="#FFFFFF" cx="47.9" cy="36.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="38.4" cy="45.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="29.8" cy="55.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="22.3" cy="66" r="1.2"/>
                    <circle fill="#FFFFFF" cx="16" cy="77.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="10.9" cy="89.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.1" cy="101.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="4.5" cy="114.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.4" cy="127.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.5" cy="140.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="5.1" cy="153.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.9" cy="165.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="12.1" cy="178" r="1.2"/>
                    <circle fill="#FFFFFF" cx="17.5" cy="189.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="24.2" cy="200.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="31.9" cy="211.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="40.7" cy="220.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="50.5" cy="229.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="61.1" cy="236.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="72.4" cy="243.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="84.3" cy="248.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="96.7" cy="252.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="109.4" cy="254.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="122.3" cy="255.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="135.3" cy="255.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="148.1" cy="254.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="160.8" cy="251.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="173.1" cy="247" r="1.2"/>
                    <circle fill="#FFFFFF" cx="184.8" cy="241.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="196" cy="235" r="1.2"/>
                    <circle fill="#FFFFFF" cx="206.4" cy="227.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="215.9" cy="218.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="224.4" cy="208.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="231.9" cy="198.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="238.2" cy="186.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="243.3" cy="174.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="247.2" cy="162.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.7" cy="149.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.9" cy="136.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.7" cy="123.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.2" cy="111" r="1.2"/>
                    <circle fill="#FFFFFF" cx="246.3" cy="98.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="242.1" cy="86.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="236.7" cy="74.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="230.1" cy="63.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="222.3" cy="52.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="213.5" cy="43.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="203.7" cy="34.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="193.2" cy="27.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="181.8" cy="20.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="69.4" cy="22.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="58.3" cy="29.1" r="1.2"/>
                    <path fill="#FFFFFF" d="M77.5,16.3l2.1-0.8l0.2,0.5c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.5,0.2,0.7,0.1c0.4-0.2,0.6-0.6,0.4-1.2
                l-1.6-4l-2.3,0.9l-0.7-1.8l4.4-1.7l2.3,5.9c0.7,1.9-0.3,3.3-1.8,3.9c-1.4,0.6-3.2,0.2-3.9-1.6L77.5,16.3z"/>
                    <path fill="#FFFFFF" d="M87.9,11.8L87.9,11.8l0-0.1c-0.2-0.5-0.6-0.6-1.1-0.4c-0.8,0.3-1.5,1.1-1.5,1.1l-1.2-1.2
                c0.6-0.8,1.4-1.4,2.4-1.7c1.8-0.6,3.1,0,3.6,1.6l1.3,3.8l-1.9,0.6l-0.1-0.4c0-0.1-0.1-0.3-0.1-0.4l0,0c0,0-0.2,1.1-1.5,1.5
                c-1.2,0.4-2.4-0.1-2.8-1.3C84.4,13.2,87,12.1,87.9,11.8z M87.8,14.6c0.5-0.2,0.8-0.9,0.7-1.4l0-0.1L88.3,13
                c-0.7,0.2-1.4,0.7-1.2,1.2C87.2,14.5,87.4,14.7,87.8,14.6L87.8,14.6z"/>
                    <path fill="#FFFFFF" d="M94,4.8l2.1-0.5L96.5,6l-2.1,0.5L94,4.8z M94.6,7.3l2.1-0.5l1.6,6.4l-2.1,0.5L94.6,7.3z"/>
                    <path fill="#FFFFFF" d="M102.7,7.3l-0.8,0.2l-0.3-1.7l0.9-0.2l-0.3-1.9l2.1-0.4l0.3,1.9l1.4-0.2l0.3,1.7L104.9,7l0.4,2
                c0.1,0.7,0.9,0.7,1.3,0.6c0.1,0,0.2,0,0.3-0.1l0.3,1.9c-0.2,0.1-0.4,0.1-0.6,0.1c-1,0.2-3.1,0.3-3.5-1.9L102.7,7.3z"/>
                    <path fill="#FFFFFF" d="M110.5,4.1c1.9-0.3,3.2,0.9,3.4,2.8c0,0.2,0,0.7,0,0.7l-4.1,0.5c0.3,0.8,1,1.1,1.7,1
                c0.9-0.1,1.7-0.9,1.7-0.9l1,1.4c-0.7,0.7-1.6,1.2-2.7,1.3c-2.3,0.3-3.8-1.2-4-2.9C107.3,6,108.4,4.4,110.5,4.1z M111.6,6.6
                c-0.1-0.5-0.5-0.9-1-0.8c-0.6,0.1-0.9,0.6-0.9,1.1L111.6,6.6z"/>
                    <path fill="#FFFFFF" d="M118.4,3.3c1.8-0.1,2.7,0.8,2.7,0.8l-0.8,1.5c-0.4-0.4-1-0.5-1.6-0.5c-1,0.1-1.5,0.9-1.5,1.7
                s0.7,1.6,1.8,1.5c0.9-0.1,1.7-0.9,1.7-0.9l0.9,1.5c0,0-0.9,1.2-2.7,1.3c-2.3,0.2-3.8-1.4-3.9-3.2C114.8,5.2,116,3.5,118.4,3.3z"/>
                    <path fill="#FFFFFF" d="M122.5,0.7l2.2,0l0,2.9c0,0.2,0,0.4,0,0.6h0c0.4-0.7,1.1-1.1,2-1.1c1.3,0,2.4,0.6,2.4,2.4l0,4.3l-2.2,0
                l0-3.9c0-0.6-0.3-0.9-0.7-0.9c-0.6,0-1.1,0.4-1.3,1c-0.1,0.3-0.1,0.6-0.1,0.8l0,2.9l-2.2,0L122.5,0.7z"/>
                    <path fill="#FFFFFF" d="M131.1,3.2l2.1,0.1l0,0.6c0,0.1,0,0.3,0,0.4h0c0.3-0.5,1-1.1,2.2-1c1.3,0.1,2.3,0.7,2.2,2.6l-0.2,4.3
                l-2.2-0.1l0.2-3.8c0-0.6-0.2-0.9-0.7-0.9c-0.6-0.1-1.2,0.3-1.4,0.9c-0.1,0.3-0.2,0.6-0.2,0.9l-0.2,2.9l-2.2-0.1L131.1,3.2z"/>
                    <path fill="#FFFFFF" d="M142.9,4c2.1,0.3,3.5,1.8,3.3,3.9c-0.3,2.1-2.1,3.2-4.1,2.9c-2.1-0.3-3.5-1.8-3.3-3.8
                C139,4.9,140.8,3.7,142.9,4z M142.3,9c0.8,0.1,1.6-0.4,1.7-1.4s-0.5-1.7-1.3-1.8s-1.6,0.4-1.7,1.4C140.9,8.2,141.5,8.9,142.3,9
                L142.3,9z"/>
                    <path fill="#FFFFFF" d="M148.4,2.4l2.2,0.4L149.5,9c-0.1,0.6,0,0.8,0.5,0.9c0.1,0,0.3,0,0.3,0l-0.3,1.9c-0.2,0-0.4,0-0.7-0.1
                c-1.2-0.2-2.3-0.7-2-2.9L148.4,2.4z"/>
                    <path fill="#FFFFFF" d="M155.6,6.2c2,0.5,3.3,2.2,2.9,4.2s-2.4,3-4.4,2.5c-2-0.5-3.3-2.2-2.9-4.2S153.6,5.8,155.6,6.2z
                 M154.5,11.1c0.8,0.2,1.6-0.3,1.8-1.2S156,8.2,155.2,8c-0.8-0.2-1.6,0.3-1.8,1.3C153.2,10.2,153.7,10.9,154.5,11.1z"/>
                    <path fill="#FFFFFF" d="M161.2,15.5c0.8,0.2,1.5,0.2,1.8-0.8l0.1-0.2c0-0.1,0.1-0.2,0.1-0.2h0c-0.5,0.3-1,0.4-1.8,0.2
                c-1.9-0.6-2.4-2.4-1.9-4s1.8-2.8,3.7-2.3c1.1,0.3,1.5,1.1,1.5,1.1l0,0c0-0.1,0-0.1,0-0.2l0.1-0.3l2,0.6l-1.7,5.7
                c-0.7,2.3-2.8,2.6-4.5,2.1c-0.8-0.3-1.6-0.7-2.2-1.3l1.1-1.4C160,15,160.6,15.3,161.2,15.5z M163.9,11.8c0.3-1.1-0.2-1.5-0.8-1.7
                c-0.7-0.2-1.3,0.2-1.5,0.9c-0.2,0.8-0.1,1.6,0.8,1.8C162.9,13,163.6,12.9,163.9,11.8L163.9,11.8z"/>
                    <path fill="#FFFFFF" d="M168.7,10.1l2.1,0.7l-2.2,6.2l-2.1-0.7L168.7,10.1z M169.6,7.7l2,0.7l-0.6,1.6l-2-0.7L169.6,7.7z"/>
                    <path fill="#FFFFFF" d="M174.8,15L174.8,15l0.1-0.1c0.2-0.5-0.1-0.8-0.6-1c-0.8-0.3-1.9-0.1-1.9-0.1l-0.1-1.7c1-0.2,2-0.1,2.9,0.2
                c1.7,0.7,2.4,2,1.7,3.6l-1.5,3.8l-1.9-0.8l0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.4l0,0c0,0-0.8,0.7-2.1,0.2c-1.1-0.5-1.8-1.6-1.3-2.8
                C171.2,13.8,173.8,14.6,174.8,15z M172.9,17c0.5,0.2,1.2-0.2,1.4-0.7l0.1-0.1l-0.2-0.1c-0.7-0.3-1.5-0.4-1.7,0.1
                C172.4,16.6,172.5,16.9,172.9,17L172.9,17z"/>
                </g>
                { props.survey.map((question, index) => {
                    return <QuestionPoint key={question.id} code={question.code} area="technology" percent={question.answers[0].percent}
                                          x={coordinates[index].x} y={coordinates[index].y}/>
                }) }
            </g>
        </svg>
    );
};

const mapStateToProps = (state) => {
    return {
        survey: state.survey.technology.questions,
    }
};

export default connect(mapStateToProps)(Technology);


Technology.defaultProps = {
    click: () => {},
};

Technology.propTypes = {
    click: PropTypes.func,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/Technology.js